// extracted by mini-css-extract-plugin
export default {"icon":"Switch_icon__-MNDp"};